(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaCalorController', MapaCalorController);

        MapaCalorController.$inject = ['$timeout', '$scope', '$stateParams', 'Propriedade', 'Safra', 'Mapaimagem', 'Configuracaomapacalor'];

    function MapaCalorController($timeout, $scope, $stateParams, Propriedade, Safra, Mapaimagem, Configuracaomapacalor) {
        var vm = this;
        
        // Vetores auxiliares
        vm.colors = ["#FF0000", "#FFFF00", "#00FF00"];
        vm.valoresPreferencias = [];
        vm.ultimoIndice = null;

        vm.carregando = false;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;    
        }

        Configuracaomapacalor.query({
            size:1000
        }, onCarregarValoresPreferencia);

        vm.valoresPreferencias = null;

        vm.onCarregarValoresPreferencia = onCarregarValoresPreferencia;
        function onCarregarValoresPreferencia(data){
            var dicionario = {};
            for (var i=0; i<data.length; i++){
                var tipo = data[i].tipomapa;
                var cultura = data[i].cultura.nomecultura;

                var chave = tipo + cultura;

                dicionario[chave] = {
                    pouco: data[i].pouco,
                    muito: data[i].muito
                }
            }
            vm.valoresPreferencias = dicionario; 
            console.log(vm.valoresPreferencias)
        }

        vm.filtroTipoMapa = null;

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null || vm.dataFimIntervalo != null){
                if(vm.dataInicioIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }
                else if(vm.dataFimIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //onsole.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo){
                        return false;
                    }
                }
                else {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo || dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }

            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {

            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }
            
            if(vm.filtroPropriedade == "" || vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            vm.dadosBaixados = Mapaimagem.queryGaleria({
                propid: vm.filtroPropriedade.id,
                size: 1000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
            
                if(data[i].csvNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                
                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                    //console.log(data[i].data);
                }
            }
            vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            //console.log(vm.dataInicioIntervalo);
        }

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.onCarregarImagensMapas = onCarregarImagensMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
                
                vm.dadosMapas[i].img = Mapaimagem.queryImagemPequena({
                    mapaid: id
                }, onCarregarImagensMapas);
            }
        }

        function onCarregarImagensMapas(data){
            //console.log(vm.dadosMapas);
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            const id = mapa.id;

            // Removendo do Google Maps
            for(var i = 0; i < vm.pontosNoMapa[id].length; i++){
                var element = vm.pontosNoMapa[id][i];
                element.setMap(null);
            }

            delete vm.pontosNoMapa[id];
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                const element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;
        vm.onCarregarCSV = onCarregarCSV;
        vm.controleTipoCultura = null;

        function adicionarMapasSelecionados(mapa){
            // Trocar mapa de lista

            vm.carregando = true;
            const id = mapa.id;

            if(vm.mapasSelecionados.length > 0){
                vm.removerMapaSelecionado(vm.mapasSelecionados[0]);
            }
            
            vm.controleTipoCultura = mapa.tipomapa + mapa.cultura_nomecultura;
            console.log(vm.controleTipoCultura);

            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                const element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;
            
            // Pegar dados do CSV
            Mapaimagem.queryCSV({
                mapaid: id
            }, vm.onCarregarCSV);

            vm.mapasSelecionados.push(mapa);
        }

        function onCarregarCSV(data){

            // Dados Carregados em Base64
            data = data[0];

            var fileData = data.csv;
            data.csv = [];

            // Dados Carregados como Blob (conversão)
            var fileBlob = vm.converteBase64ToCSV(fileData, "application/vnd.ms-excel");

            // FileReader
            var readerCSV = new FileReader();

            vm.pontosNoMapa[data.id] = [];

            readerCSV.onload = function () {
                var dadosCSV = readerCSV.result;
                var linhas = dadosCSV.split('\n');
                
                var valores = [];

                for (var index = 0; index < linhas.length; index++) {
                    const element = linhas[index];

                    if(element == "") continue;

                    var sequenciaPontos = vm.converteStringPontos(element);
                    //console.log(sequenciaPontos);

                    data.csv.push(sequenciaPontos);
                    var lat = sequenciaPontos[0];
                    var lng = sequenciaPontos[1];

                    var qtd = sequenciaPontos[2];

                    var preferencia = vm.valoresPreferencias[vm.controleTipoCultura]

                    var pouco = preferencia.pouco;
                    var muito = preferencia.muito;

                    var PTemp1 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 0);
                    var PTemp2 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 90);
                    var PTemp3 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 180);
                    var PTemp4 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, -90);

                    var P1 = new google.maps.LatLng(PTemp1.lat(), PTemp4.lng());
                    var P2 = new google.maps.LatLng(PTemp1.lat(), PTemp2.lng());
                    var P3 = new google.maps.LatLng(PTemp3.lat(), PTemp2.lng());
                    var P4 = new google.maps.LatLng(PTemp3.lat(), PTemp4.lng());

                    //console.log(P1.lat());

                    var sequenciaPontos = [P1, P2, P3, P4, P1];

                    var point = null;

                    if(qtd <= pouco){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#00FF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#00FF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd > pouco && qtd <muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FFFF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd >= muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FF0000",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                
                    vm.pontosNoMapa[data.id].push(point);
                    
                    if(index==0){
                        vm.map.setCenter(new google.maps.LatLng(lat, lng));
                    }

                }

                vm.carregando = false;

            }
            readerCSV.readAsText(fileBlob);

            //console.log(fileData);
        }


        // Google Maps
        vm.map = null;
        vm.initMap = initMap;
        
        vm.pontosNoMapa = {};

        function initMap() {
            vm.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: -24.283362, lng: -53.839970},
                zoom: 15,
                mapTypeId: 'satellite'
            });
        }

        initMap();

        vm.converteBase64ToCSV = converteBase64ToCSV;
        function converteBase64ToCSV(b64Data, contentType) {
    
            var sliceSize = 512
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        vm.converteStringPontos = converteStringPontos;
        function converteStringPontos(linha){
            linha = linha.split(';');

            var geo = linha[0];
            geo = geo.slice(1, geo.length-1);
            geo = geo.replace(' ', '');
            geo = geo.split(',');

            var lat = geo[0];
            var lng = geo[1];

            var qtd = linha[1];

            var vetor = new Array();
            vetor.push(lat); vetor.push(lng); vetor.push(qtd);

            return vetor;
        }

        vm.retornaAleatorio = retornaAleatorio;
        function retornaAleatorio(min, max){
            return Math.floor(Math.random() * (max - min)) + min;
        }

        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

    }
})();
